module.exports = {"511824002":"新棉街道","511824101":"回隆镇","511824102":"美罗镇","511824106":"安顺场镇","511824202":"蟹螺藏族乡","511824203":"永和乡","511824206":"栗子坪彝族乡","511824208":"迎政乡","511824210":"丰乐乡","511824211":"新民藏族彝族乡","511824214":"草科藏族乡","511824216":"王岗坪彝族藏族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511824.json
// module id = 2515
// module chunks = 0